import { UnfoldLess, UnfoldMore } from "@mui/icons-material";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { MarkdownText } from "../../ui/MarkdownText";

interface ThinkingBlockProps {
  thinkingMessages: string[];
  defaultExpanded?: boolean;
}

export function ThinkingBlock({
  thinkingMessages,
  defaultExpanded = false,
}: ThinkingBlockProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="overflow-hidden rounded-md border border-solid border-gray-300 bg-white">
      {/* Clickable Header - Functions as the expand/collapse button */}
      <div
        className="flex w-full items-center justify-between p-2 bg-gray-50 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center gap-2 text-sm text-gray-500 transition-colors duration-200 ease-in-out hover:text-gray-700 cursor-pointer border-0 outline-none focus:outline-none bg-transparent text-left"
        >
          Reasoning
        </button>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex-shrink-0 flex items-center justify-center cursor-pointer border-0 outline-none focus:outline-none bg-transparent"
        >
          {isExpanded ? (
            <UnfoldLess className="h-4 w-4 text-gray-500 rotate-180" />
          ) : (
            <UnfoldMore className="h-4 w-4 text-gray-500" />
          )}
        </button>
      </div>

      {/* Thinking Content - Only show when expanded */}
      {isExpanded && (
        <div className="border-t border-gray-300">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={isExpanded ? "expanded" : "collapsed"}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.2 }}
              className="p-3"
            >
              <div className="space-y-2">
                {thinkingMessages.map((message, index) => (
                  <div key={index} className="text-sm text-gray-600">
                    <MarkdownText>{message}</MarkdownText>
                  </div>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      )}
    </div>
  );
}
